import { Button } from "@component-ui/utility/Button";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@component-ui/utility/Tooltip";
import useSoftDeleteDocumentMutate from "@hooks/document/useSoftDeleteDocumentMutate";
import { Loader, Trash } from "lucide-react";
import { FC } from "react";

type SoftDeleteDocumentButtonProps = {
    id: string;
};

const SoftDeleteDocumentButton: FC<SoftDeleteDocumentButtonProps> = ({
    id,
}) => {
    const { mutateAsync: deleteDocument, isPending } =
        useSoftDeleteDocumentMutate();

    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={(e) => {
                            e.stopPropagation();
                            deleteDocument(id);
                        }}
                    >
                        {isPending ? (
                            <Loader className="animate-spin" />
                        ) : (
                            <Trash />
                        )}
                    </Button>
                </TooltipTrigger>
                <TooltipContent>Delete document</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default SoftDeleteDocumentButton;
